import {PermitteeType} from "~/enums/permitteeType";
import {Logger} from "~/services/logger";

export default {
  data: function() {
    return {
      assignableEnum: PermitteeType,
    };
  },
  mounted() {
    this.checkAssignableMixinInitialization();
  },
  methods: {
    getAssigneePropsFromOption(option) {
      let props = null;
      switch (option.optionType) {
        case this.assignableEnum.originalSubmitter:
          props = {
            reference_id: (<number>this.assignableEnum.originalSubmitter).toString(),
            reference_type: this.assignableEnum.originalSubmitter,
          };
          break;
        case this.assignableEnum.entityOwner:
          props = {
            reference_id: (<number>this.assignableEnum.entityOwner).toString(),
            reference_type: this.assignableEnum.entityOwner,
          };
          break;
        case this.assignableEnum.allApprovers:
          props = {
            reference_id: (<number>this.assignableEnum.allApprovers).toString(),
            reference_type: this.assignableEnum.allApprovers,
          };
          break;
        case this.assignableEnum.allCompleters:
          props = {
            reference_id: (<number>this.assignableEnum.allCompleters).toString(),
            reference_type: this.assignableEnum.allCompleters,
          };
          break;
        case this.assignableEnum.stepCompleters:
          props = {
            reference_id: (<number>this.assignableEnum.stepCompleters).toString(),
            reference_type: this.assignableEnum.stepCompleters,
          };
          break;
        case this.assignableEnum.group:
          props = {
            reference_id: option.id,
            reference_type: this.assignableEnum.group,
            name: option.name,
          };
          break;
        case this.assignableEnum.user:
          props = {
            reference_id: option.id,
            reference_type: this.assignableEnum.user,
            first_name: option.first_name,
            last_name: option.last_name,
            activation_status: option.activation_status,
          };
          break;
        case this.assignableEnum.thirdParty:
          props = {
            reference_id: option.client_id,
            reference_type: this.assignableEnum.thirdParty
          };
          break;
        case this.assignableEnum.email:
          props = {
            reference_id: option.id,
            reference_type: this.assignableEnum.email
          };
          break;
        case this.assignableEnum.objectOwner:
          props = {
            reference_id: this.assignableEnum.objectOwner.toString(),
            reference_type: this.assignableEnum.objectOwner
          };
          break;
        case this.assignableEnum.relatedObjectOwner:
          props = {
            reference_id: option.client_id,
            reference_type: this.assignableEnum.relatedObjectOwner,
            name: option.label,
          };
          break
        case this.assignableEnum.anyone: // fallthrough
        case this.assignableEnum.anyoneInApp:
          props = {
            reference_id: option.optionType.toString(),
            reference_type: option.optionType,
          };
          break;
        case this.assignableEnum.accountRelation:
          props = {
            reference_id: option.client_id,
            reference_type: this.assignableEnum.accountRelation,
            name: option.label,
          };
          break;
        case this.assignableEnum.lookupField:
          props = {
            reference_id: option.client_id,
            reference_type: this.assignableEnum.lookupField
          };
          break;
        case this.assignableEnum.entityAccountRelation:
          props = {
            reference_id: option.value,
            reference_type: this.assignableEnum.entityAccountRelation,
            name: option.label,
          };
          break;
        default:
          Logger.errorOnce('AssignableMixin#getAssigneePropsFromOption', 'PermitteeType props not defined!');
      }
      return props;
    },
    destroyAssignee(option) {
      let assignee = null;
      switch (option.optionType) {
        case this.assignableEnum.originalSubmitter: // fallthrough
        case this.assignableEnum.entityOwner: // fallthrough
        case this.assignableEnum.allApprovers: // fallthrough
        case this.assignableEnum.allCompleters: // fallthrough
        case this.assignableEnum.objectOwner: // fallthrough
        case this.assignableEnum.anyone: // fallthrough
        case this.assignableEnum.anyoneInApp: // fallthrough
        case this.assignableEnum.entityAccountRelation: // fallthrough
        case this.assignableEnum.stepCompleters:
          assignee = this.assigneeCollection.find(r => r.reference_id === option.value);
          break;
        case this.assignableEnum.relatedObjectOwner: // fallthrough
        case this.assignableEnum.accountRelation: // fallthrough
        case this.assignableEnum.thirdParty:
          assignee = this.assigneeCollection.find(r => r.reference_id === option.client_id);
          break;
        case this.assignableEnum.lookupField: // fallthrough
        default:
          assignee = this.assigneeCollection.find(r => r.reference_id === option.id);
          break;
      }
      this.removeAssignee(assignee);
    },
    checkAssignableMixinInitialization() {
      if (!this.assignableEnum) {
        throw new Error("You have not assigned the assignable enumerable.");
      }
      if (!this.assigneeCollection) {
        throw new Error("You have not set the assignable collection.");
      }
      if (!this.removeAssignee) {
        throw new Error("You have not set the remove assignee function.");
      }
    }
  }
};
